import { patchState, signalStore, type, withComputed, withMethods } from '@ngrx/signals';
import { removeAllEntities, removeEntity, setEntities, setEntity, updateEntity, withEntities, SelectEntityId } from '@ngrx/signals/entities';
import { IFilter, IFiltersInstance } from '../interfaces';
import { computed } from '@angular/core';

const selectKey: SelectEntityId<IFiltersInstance> = (filter) => filter.key;

export const FilterStore = signalStore(
	{ providedIn: 'root', protectedState: true },
	withEntities({ entity: type<IFiltersInstance>(), collection: 'filters' }),
	withComputed((store) => ({
		filters: computed(() => store.filtersEntities())
	})),
	withMethods((store) => ({
		getByKey: (key: string): IFiltersInstance | undefined => store.filtersEntityMap()[key],
		removeAll: () => patchState(store, removeAllEntities({ collection: 'filters' })),
		remove: (key: string) => patchState(store, removeEntity(key, { collection: 'filters' })),
		setAll: (filters: IFiltersInstance[]) => patchState(store, setEntities(filters, { collection: 'filters', selectId: selectKey })),
		set: (filter: IFiltersInstance) => patchState(store, setEntity(filter, { collection: 'filters', selectId: selectKey })),
		update: (key: string, changes: Partial<IFiltersInstance>) => {
			patchState(store, updateEntity({ id: key, changes: changes }, { collection: 'filters', selectId: selectKey }));
		}
	})),
	withMethods((store) => ({
		setFilterInstance(key: string, changes: Partial<IFiltersInstance>) {
			const filtersInstance = store.getByKey(key);

			store.set({ key, ...filtersInstance, ...changes });

			return { ...filtersInstance, ...changes };
		},
		getFilterMap(key: string): { [key: string]: IFilter } | null {
			const filtersInstance = store.getByKey(key);
			return filtersInstance?.filterMap ?? null;
		}
	}))
);
